import { render } from "./GeneralSettings.vue?vue&type=template&id=a70bb678&scoped=true"
import script from "./GeneralSettings.vue?vue&type=script&lang=js"
export * from "./GeneralSettings.vue?vue&type=script&lang=js"

import "./GeneralSettings.vue?vue&type=style&index=0&id=a70bb678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a70bb678"]])

export default __exports__